import React, { useState } from "react";
import ReactPlayer from "react-player";

const VideoPlayerWithThumbnail = ({ videoUrl, thumbnailUrl }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <div style={{ position: "relative", width: "100%", paddingTop: "56.25%" }}>
      {/* Display thumbnail when video is not playing */}
      {!isPlaying && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            cursor: "pointer",
          }}
          onClick={() => setIsPlaying(true)} // Start video on click
        >
          <img
            src={thumbnailUrl}
            alt="Video Thumbnail"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              borderRadius: "50%",
              width: "80px",
              height: "80px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              width="40px"
              height="40px"
            >
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
      )}

      {/* Render video player only when playing */}
      {isPlaying && (
        <ReactPlayer
          url={videoUrl}
          playing={isPlaying}
          controls={true}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
          }}
          width="100%"
          height="100%"
        />
      )}
    </div>
  );
};

export default VideoPlayerWithThumbnail;
